import React, { useEffect, useState } from 'react';
import { db } from '../../firebase/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { motion, AnimatePresence } from 'framer-motion';

const CouponForm = ({ couponCode, setCouponCode, validateCoupon }) => {
  const [message, setMessage] = useState({ text: '', type: '' });
  const [showCoupons, setShowCoupons] = useState(false);
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'offers'));
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        const activeCoupons = data.filter(offer => offer.enabled);
        setCoupons(activeCoupons);
      } catch (error) {
        console.error('Error fetching coupons:', error);
      }
    };

    fetchCoupons();
  }, []);

  const handleApplyCoupon = () => {
    const result = validateCoupon(couponCode);
    setMessage({
      text: result,
      type: result.includes('applied') ? 'success' : 'error'
    });
  };

  const handleSelectCoupon = (code) => {
    setCouponCode(code);
    setShowCoupons(false);
    const result = validateCoupon(code);
    setMessage({
      text: result,
      type: result.includes('applied') ? 'success' : 'error'
    });
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-2">
        <label className="text-gray-700 font-medium">Apply Coupon Code</label>
        <button
          onClick={() => setShowCoupons(!showCoupons)}
          className="text-purple-600 text-sm font-medium flex items-center"
        >
          {showCoupons ? 'Hide Coupons' : 'View Coupons'}
        </button>
      </div>

      <div className="flex space-x-1">
        <input
          type="text"
          value={couponCode}
          onChange={(e) => {
            setCouponCode(e.target.value);
            setMessage({ text: '', type: '' });
          }}
          placeholder="Enter coupon code"
          className="flex-1 border border-gray-300 rounded-lg px-2 py-3 text-sm focus:ring-2 focus:ring-purple-500"
        />
        <button
          onClick={handleApplyCoupon}
          className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-3 py-3 rounded-lg text-sm font-medium"
        >
          Apply
        </button>
      </div>

      {message.text && (
        <motion.p
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          className={`mt-2 text-sm ${message.type === 'success' ? 'text-green-600' : 'text-red-500'}`}
        >
          {message.text}
        </motion.p>
      )}

      <AnimatePresence>
        {showCoupons && (
          <motion.div
            initial={{ opacity: 0, x: 300 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 300 }}
            className="mt-4"
          >
            <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-xl p-4 border">
              <h3 className="text-sm font-semibold text-purple-800 mb-3">Available Coupons</h3>
              <div className="space-y-3">
                {coupons.map((coupon, idx) => (
                  <motion.div
                    key={idx}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={() => handleSelectCoupon(coupon.code)}
                    className="flex justify-between items-center bg-white p-3 rounded-lg border cursor-pointer"
                  >
                    <div>
                      <div className="flex items-center">
                        <span className="font-bold text-purple-700 mr-2">{coupon.code}</span>
                        <span className="bg-purple-100 text-purple-800 text-xs px-2 py-0.5 rounded-full">
                          {coupon.type === 'percentage' ? `${coupon.discount}%` : coupon.type === 'fixed' ? `₹${coupon.discount}` : 'BOGO'}
                        </span>
                      </div>
                      <p className="text-gray-600 text-xs mt-1">{coupon.title}</p>
                    </div>
                    <button className="bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                      APPLY
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CouponForm;
